import {QueryFunctionContext} from 'react-query';
import request from '../../axios';

export const getAllWaterSystem = async (ctx: QueryFunctionContext) => {
  const {data}: {data: IWaterSystem[]} = await request.get(
    `/api/v2/farm/water-system`,
  );

  return data;
};
